import { tokens } from '@arvoreeducacao/bonsai-ds'
import type { IconsType } from '@arvoreeducacao/bonsai-core'
import { type IViewOptionsDegrees } from './SegmentAndContentTab.type'

export const lerTabsItems = ({
  shouldSeeNewsAndMagazinesTab,
  shouldSeeArticlesTab,
  shouldSeeVideosTab,
  shouldSeePodcastsTab,
  shouldSeeCursosTab,
  newsTab
}: {
  shouldSeeNewsAndMagazinesTab: boolean
  shouldSeeArticlesTab: boolean
  shouldSeeVideosTab: boolean
  shouldSeePodcastsTab: boolean
  shouldSeeCursosTab: boolean
  newsTab: boolean
}) => {
  const selectedColor = tokens.colors.blue400
  const backgroundColor = tokens.colors.blue200

  return [
    {
      id: 'livros',
      iconName: 'book-open' as IconsType,
      label: 'Livros',
      selectedColor,
      backgroundColor
    },
    ...(shouldSeeArticlesTab
      ? [
          {
            id: 'noticias',
            iconName: 'newspaper' as IconsType,
            label: 'Notícias',
            selectedColor,
            backgroundColor
          }
        ]
      : []),
    ...(!newsTab && shouldSeeNewsAndMagazinesTab
      ? [
          {
            id: 'revistas-e-jornais',
            iconName: 'magazine' as IconsType,
            label: 'Revistas e Jornais',
            selectedColor,
            backgroundColor
          }
        ]
      : []),
    ...(shouldSeeVideosTab
      ? [
          {
            id: 'videos',
            iconName: 'play-circle' as IconsType,
            label: 'Vídeos',
            selectedColor,
            backgroundColor
          }
        ]
      : []),
    ...(shouldSeePodcastsTab
      ? [
          {
            id: 'podcasts',
            iconName: 'mic' as IconsType,
            label: 'Podcasts',
            selectedColor,
            backgroundColor
          }
        ]
      : []),
    ...(shouldSeeCursosTab
      ? [
          {
            id: 'trilhas',
            iconName: 'book-open' as IconsType,
            label: 'Trilhas',
            selectedColor,
            backgroundColor
          }
        ]
      : [])
  ]
}

export const sentirTabsItems = [
  {
    id: 'conteudo',
    iconName: 'content' as IconsType,
    label: 'Conteúdo',
    selectedColor: tokens.colors.purple400,
    backgroundColor: tokens.colors.purple200
  },
  {
    id: 'diario',
    iconName: 'happy' as IconsType,
    label: 'Diário de emoções',
    selectedColor: tokens.colors.purple400,
    backgroundColor: tokens.colors.purple200
  }
]

export const mapModuleToLerTabId = {
  livros: 'LIVROS',
  noticias: 'NOTICIAS',
  'revistas-e-jornais': 'REVISTAS_JORNAIS',
  videos: 'VIDEOS',
  trilhas: 'TRILHAS'
}

export const mapModuleToSentirTabId = {
  sentir: 'SENTIR',
  diariodeemocoes: 'DIARIO_DE_EMOCOES'
}

export const viewOptionsDegrees: Array<IViewOptionsDegrees> = [
  { id: 'F', text: 'Todos' },
  { id: 'KIDS1', text: 'Educação infantil' },
  { id: 'KIDS2', text: 'Anos iniciais do fundamental' },
  { id: 'EF2', text: 'Anos finais do fundamental' },
  { id: 'M', text: 'Ensino Médio' }
]
